import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, ViewChild, NgModule, Directive, HostListener } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { CoerceBoolean } from '@slidebean/hydra/coercion';

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class FilePickerComponent {
    constructor() {
        this.accept = 'image/*';
        this.selected = new EventEmitter();
    }
    open() {
        if (!this.input || this.disabled)
            return;
        this.input.nativeElement.click();
    }
    onSelected() {
        const files = this.input.nativeElement.files;
        if (!files)
            return;
        this.selected.emit(files[0]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: FilePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.1.4", type: FilePickerComponent, selector: "hy-file-picker", inputs: { accept: "accept", disabled: "disabled" }, outputs: { selected: "selected" }, viewQueries: [{ propertyName: "input", first: true, predicate: ["file"], descendants: true, static: true }], ngImport: i0, template: ` <input
      #file
      type="file"
      [attr.accept]="accept"
      tabindex="-1"
      [attr.disabled]="disabled || null"
      [attr.aria-disabled]="disabled || null"
      (change)="onSelected()"
      style="position:absolute; top:-9999px; left:-9999px"
    />
    <a
      role="button"
      (click)="open()"
      [ngStyle]="{
        'display': 'block',
        'pointer-events': disabled ? 'none' : null,
        'cursor': disabled ? 'not-allowed' : null
      }"
    >
      <ng-content></ng-content>
    </a>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
__decorate([
    CoerceBoolean()
], FilePickerComponent.prototype, "disabled", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: FilePickerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'hy-file-picker',
                    template: ` <input
      #file
      type="file"
      [attr.accept]="accept"
      tabindex="-1"
      [attr.disabled]="disabled || null"
      [attr.aria-disabled]="disabled || null"
      (change)="onSelected()"
      style="position:absolute; top:-9999px; left:-9999px"
    />
    <a
      role="button"
      (click)="open()"
      [ngStyle]="{
        'display': 'block',
        'pointer-events': disabled ? 'none' : null,
        'cursor': disabled ? 'not-allowed' : null
      }"
    >
      <ng-content></ng-content>
    </a>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { accept: [{
                type: Input
            }], disabled: [{
                type: Input
            }], selected: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ['file', { static: true }]
            }] } });
const DIRECTIVES$1 = [FilePickerComponent];
class FilePickerModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: FilePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: FilePickerModule, declarations: [FilePickerComponent], imports: [CommonModule], exports: [FilePickerComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: FilePickerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: FilePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: DIRECTIVES$1,
                    exports: DIRECTIVES$1,
                    imports: [CommonModule],
                }]
        }] });

class DropZoneDirective {
    constructor() {
        this.accept = 'image/*';
        this.onDragEnter = new EventEmitter();
        this.onDragLeave = new EventEmitter();
        this.onDropFile = new EventEmitter();
        this.dragEnterCount = 0;
    }
    _onDragEnter(event) {
        event.stopPropagation();
        event.preventDefault();
        if (this.dragEnterCount === 0) {
            let isAccepted = true;
            try {
                const items = (event.dataTransfer && event.dataTransfer.items) || [];
                const file = items && items.length ? items[0] : null;
                if (file) {
                    isAccepted = this.isFileAccepted(file);
                }
            }
            catch (_) {
                // Default to true, just in case
                isAccepted = true;
            }
            this.onDragEnter.emit(isAccepted);
        }
        this.dragEnterCount++;
        return false;
    }
    _onDragLeave(event) {
        event.stopPropagation();
        event.preventDefault();
        this.dragEnterCount = Math.max(0, this.dragEnterCount - 1);
        if (this.dragEnterCount === 0) {
            this.onDragLeave.emit();
        }
        return false;
    }
    _onDragOver(event) {
        event.stopPropagation();
        event.preventDefault();
        return false;
    }
    _onDrop(event) {
        event.stopPropagation();
        event.preventDefault();
        const files = (event.dataTransfer && event.dataTransfer.files) || [];
        const file = files && files.length ? files[0] : null;
        if (file && this.isFileAccepted(file)) {
            this.onDropFile.emit(file);
        }
        else {
            this.onDragLeave.emit();
        }
        // Reset drag enter count
        this.dragEnterCount = 0;
        return false;
    }
    isFileAccepted(file) {
        let accepted = false;
        try {
            const regex = `${this.accept}`
                .replace(/,/g, '|')
                .replace(/\//g, '\\/')
                .replace(/\./g, '\\.');
            accepted = !!file.type.match(new RegExp(regex, 'i'));
        }
        catch (error) {
            console.warn('Could not determine whether file type is accepted', file, this.accept, error);
        }
        finally {
            return accepted;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: DropZoneDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.1.4", type: DropZoneDirective, selector: "[hy-drop-zone]", inputs: { accept: "accept" }, outputs: { onDragEnter: "onDragEnter", onDragLeave: "onDragLeave", onDropFile: "onDropFile" }, host: { listeners: { "dragenter": "_onDragEnter($event)", "dragleave": "_onDragLeave($event)", "dragover": "_onDragOver($event)", "drop": "_onDrop($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: DropZoneDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[hy-drop-zone]',
                }]
        }], propDecorators: { accept: [{
                type: Input
            }], onDragEnter: [{
                type: Output
            }], onDragLeave: [{
                type: Output
            }], onDropFile: [{
                type: Output
            }], _onDragEnter: [{
                type: HostListener,
                args: ['dragenter', ['$event']]
            }], _onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], _onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], _onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });
const DIRECTIVES = [DropZoneDirective];
class DropZoneModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: DropZoneModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: DropZoneModule, declarations: [DropZoneDirective], exports: [DropZoneDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: DropZoneModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: DropZoneModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: DIRECTIVES,
                    exports: DIRECTIVES,
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DropZoneDirective, DropZoneModule, FilePickerComponent, FilePickerModule };
